import availableFonts from '../../../../constants/AvailableFonts';
import platformDetection from '../../../utils/PlatformDetection';
import configuration from '../../../../constants/Configuration';
import appParameters from '../../../utils/AppParameters';
import storeManager from '../../../../store/StoreManager';
import modeType from '../../../../constants/ModeConstants';
import { changeContextMode, setContextTarget } from '../../../../actions/MenuActions';
import { changeRichTextContent, updateTextHeight } from '../../../../actions/CurrentSlideActions';
import mouseUtils from '../../../utils/MouseUtils';
import saveManager from '../../../utils/SaveManager';
import audioEditorUtils from '../../../audioEditor/utils/AudioEditorUtils';
import properties from '../../../../constants/Properties';
import textSizeUtils from '../../../utils/TextSizeUtils';
import mindMapUtils from "../../../utils/MindMapUtils";

const textEditorUtils = {
    selectedTextShape: '',
    isClick: false, // used to know if is click or drag-drop when move shape
    isShapeAlreadySelected: false, // used to know if a shape is already selected or not before clicking on it
    currentFont: availableFonts.defaultFont,
    defaultFontSize: 24,
    currentFontSize: 24,
    savedSelection: undefined,
    lastCursorPosition: -1, // used to know where the last click was done on text area

    useRichText() {
        if (platformDetection.isIOS()) // keep the old functionality for IOS
            return false;

        return true;

        let testUsers = [15682463, 54719315, 54829736, 54829790, 54829795, 54829800];

        if (!configuration.IS_PROD() || configuration.LOAD_LOCAL || (configuration.IS_PROD() && testUsers.indexOf(appParameters.currentUserId) != -1))
            return true;
        else
            return false;
    },
    isTextEditorTool() {
        if (storeManager.getState().menu.contextMode == modeType.TEXT_EDITOR)
            return true;
        else
            return false;
    },
    isInteractiveTextElementFocused() {
        let activeElement = document.activeElement;

        if (activeElement && activeElement.id.indexOf('interactiveElement_') != -1)
            return true;
        else
            return false;
    },
    openTextEditorTool(shapeModel, keyboardCharacter) {
        this.isClick = false;
        this.resetActions();

        if (storeManager.getState().menu.contextMode == modeType.SIZE_AND_POSITION_CONTEXT || storeManager.getState().menu.contextMode == modeType.ANIMATION_CONTEXT)
            return;

        const dispatch = storeManager.getStore().dispatch;
        dispatch(setContextTarget(shapeModel, false));

        mouseUtils.activeElement = shapeModel.uuid; // used for tab sequence

        setTimeout(function () {
            let textArea = document.getElementById('text_area_' + shapeModel.uuid);

            if (textArea) {
                textArea.style.cursor = 'text';
                textArea.contentEditable = true;

                textArea.focus();
                this.setCursorAtLastPosition(textArea, shapeModel, keyboardCharacter);
            }

            this.selectedTextShape = shapeModel.uuid;

            setTimeout(function() {
                dispatch(changeContextMode(modeType.TEXT_EDITOR));
            }.bind(this), 2);
        }.bind(this), 2);
    },
    setCursorAtLastPosition(contentElement, shapeModel, keyboardCharacter) {
        var revertUnderline = this.isUnderlineAction && !this.isUnderline; // when we try to revert underline, then the 'text-decoration-line == none' doesn't work to remove also the underline from the parent, so the new node with non-underline should be added outside of the parent node with underline to not inherit the underline property.
        var revertSuper = this.isSuperAction && !this.isSuper;
        var revertSub = this.isSubAction && !this.isSub;

        if (this.savedSelection && !revertUnderline && !revertSuper && !revertSub) // set previous selection
            this.restoreSelection(document.getElementById('text_area_' + shapeModel.uuid));
        else { // add cursor at the end
            const range = document.createRange();
            const selection = window.getSelection();

            if (contentElement.childNodes.length > 0 && !this.isUnderlineAction  && !this.isSuperAction && !this.isSubAction) {
                var lastChildren = this.getLastChildren(contentElement);

                if (lastChildren) {
                    if (lastChildren.length > 0)
                        range.setStart(this.getLastChildren(contentElement), lastChildren.length);
                    else
                        range.setStart(this.getLastChildren(contentElement), 0);
                }
            } else
                range.setStart(contentElement, contentElement.childNodes.length);

            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }

        if (!keyboardCharacter)
            return;

        if (this.isPrintableCharacter(keyboardCharacter.keyCode))
            this.insertTextAtCursor(shapeModel, keyboardCharacter.key);
    },
    insertTextAtCursor(shapeModel, text) {
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);
        range.deleteContents();

        let node = document.createTextNode(text);
        let span = document.createElement('span');

        span.style.fontSize = this.currentFontSize + 'px';
        span.style.fontFamily = this.currentFont;

        if (this.isBoldAction) {
            if (this.isBold)
                span.style['font-weight'] = 'bold';
            else
                span.style['font-weight'] = 'normal';
        }

        if (this.isItalicAction) {
            if (this.isItalic)
                span.style['font-style'] = 'italic';
            else
                span.style['font-style'] = 'normal';
        }

        if (this.isUnderlineAction) {
            if (this.isUnderline)
                span.style['text-decoration-line'] = 'underline';
        }

        if (this.isSuperAction) {
            if (this.isSuper)
                span.style['vertical-align'] = 'super';
        }

        if (this.isSubAction) {
            if (this.isSub)
                span.style['vertical-align'] = 'sub';
        }

        if (this.isFontColorAction && this.fontColor)
            span.style['color'] = this.fontColor;

        span.appendChild(node);
        range.insertNode(span);

        for(let position = 0; position != text.length; position++) {
            selection.modify('move', 'right', 'character');
        }

        this.updateShapeSize(shapeModel, storeManager.getStore().dispatch);
    },
    getLastChildren(contentElement) {
        if (contentElement.childNodes.length > 0)
            return this.getLastChildren(contentElement.childNodes[contentElement.childNodes.length - 1]);
        else
            return contentElement;
    },
    isPrintableCharacter(keycode) {
        if ((keycode > 47 && keycode < 58)   || // number keys
            (keycode > 64 && keycode < 91)   || // letter keys
            (keycode > 95 && keycode < 112)  || // numpad keys
            (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
            (keycode > 218 && keycode < 223))   // [\]' (in order)
            return true;
        else
            return false;
    },
    saveSelection(containerEl) {
        let start;

        if (window.getSelection && document.createRange) {
            let range = window.getSelection().getRangeAt(0);
            let preSelectionRange = range.cloneRange();

            preSelectionRange.selectNodeContents(containerEl);
            preSelectionRange.setEnd(range.startContainer, range.startOffset);
            start = preSelectionRange.toString().length;

            this.savedSelection = { start: start, end: start + range.toString().length };
        } else if (document.selection) {
            let selectedTextRange = document.selection.createRange();
            let preSelectionTextRange = document.body.createTextRange();

            preSelectionTextRange.moveToElementText(containerEl);
            preSelectionTextRange.setEndPoint("EndToStart", selectedTextRange);

            let start = preSelectionTextRange.text.length;

            this.savedSelection = { start: start, end: start + selectedTextRange.text.length };
        }
    },
    restoreSelection(containerEl) {
        let savedSel = this.savedSelection;

        if (window.getSelection && document.createRange) {
            let charIndex = 0, range = document.createRange();
            range.setStart(containerEl, 0);
            range.collapse(true);
            let nodeStack = [containerEl], node, foundStart = false, stop = false;

            while (!stop && (node = nodeStack.pop())) {
                if (node.nodeType == 3) {
                    let nextCharIndex = charIndex + node.length;
                    if (!foundStart && savedSel.start >= charIndex && savedSel.start <= nextCharIndex) {
                        range.setStart(node, savedSel.start - charIndex);
                        foundStart = true;
                    }
                    if (foundStart && savedSel.end >= charIndex && savedSel.end <= nextCharIndex) {
                        range.setEnd(node, savedSel.end - charIndex);
                        stop = true;
                    }
                    charIndex = nextCharIndex;
                } else {
                    let i = node.childNodes.length;
                    while (i--) {
                        nodeStack.push(node.childNodes[i]);
                    }
                }
            }

            let sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (document.selection) {
            let textRange = document.body.createTextRange();
            textRange.moveToElementText(containerEl);
            textRange.collapse(true);
            textRange.moveEnd("character", savedSel.end);
            textRange.moveStart("character", savedSel.start);
            textRange.select();
        }
    },
    checkForSizeAttribute(parentElement) {
        let innerHtml = parentElement.innerHTML;

        if (innerHtml && (innerHtml.indexOf('xxx-large') != -1 || innerHtml.indexOf('<img') != -1)) // the size was change when there was no text selection, so the "font-size: xxx-large" attribute was set there ORRRRR an image was inserted with copy/Paste
            this.checkChildrenNodes(parentElement);

        if (innerHtml && innerHtml.indexOf('<li') != -1) // check for the font-size of the first element inside of LI node
            this.checkListNodes(parentElement);
    },
    checkChildrenNodes(parentElement) {
        let childNodes = parentElement.children;

        if (childNodes && childNodes.length > 0) {
            for (let i = 0; i < childNodes.length; i++) {
                let node = childNodes[i];

                if (node && node.style.fontSize && node.style.fontSize === 'xxx-large')
                    node.style.fontSize = this.currentFontSize + 'px';

                if (node && node.nodeName === 'IMG')
                    node.remove();

                this.checkChildrenNodes(node);
            }
        }
    },
    checkListNodes(parentElement) {
        let childNodes = parentElement.children;

        if (childNodes && childNodes.length > 0) {
            for (let i = 0; i < childNodes.length; i++) {
                let node = childNodes[i];

                if (node && node.nodeName === 'LI') {
                    let fontSize = this.getFontSizeFromFirstNode(node);

                    if (fontSize > 0)
                        node.style.fontSize = fontSize + 'px';

                    if (node.parentNode.nodeName === 'OL' || node.parentNode.nodeName === 'UL') {
                        node.parentNode.style['padding-left'] = '0px';
                        node.parentNode.style['list-style-position'] = 'inside';
                    }
                }

                this.checkListNodes(node);
            }
        }
    },
    getFontSizeFromFirstNode(parentElement) {
        let childNodes = parentElement.children;
        let currentNodeFontSize = 0;

        if (childNodes && childNodes.length > 0) {
            let node = childNodes[0];

            if (node && node.style.fontSize)
                currentNodeFontSize = parseInt(node.style.fontSize);

            if (currentNodeFontSize > 0)
                return currentNodeFontSize;

            return this.getFontSizeFromFirstNode(node);
        }

        return currentNodeFontSize;
    },

    isBoldAction: false,
    isBold: false,
    isItalicAction: false,
    isItalic: false,
    isUnderlineAction: false,
    isUnderline: false,
    isSuperAction: false,
    isSuper: false,
    isSubAction: false,
    isSub: false,
    isFontColorAction: false,
    fontColor: undefined,
    isFontFamilyAction: false,
    fontFamily: undefined,
    isFontSizeAction: false,
    fontSize: undefined,

    executeAction(index, value) { // when click on Bold, Italic, Underline, Super, Sub, font Color button, font Family button
        let selection = window.getSelection();

        if (selection.anchorOffset === selection.extentOffset) // no text selected and only the cursor pointer
            this.lastCursorPosition = selection.anchorOffset;
        else
            this.lastCursorPosition = -1;

        this.saveSelection(document.getElementById('text_area_' + this.selectedTextShape));

        switch (index) {
            case 1: { // bold
                if (this.isBoldAction)
                    this.isBold = !this.isBold;
                else
                    this.isBold = !this.isSelectedStyle('bold');

                this.isBoldAction = true;
                break;
            }
            case 2: { // italic
                if (this.isItalicAction)
                    this.isItalic = !this.isItalic;
                else
                    this.isItalic = !this.isSelectedStyle('italic');

                this.isItalicAction = true;
                break;
            }
            case 3: { // underline
                if (this.isUnderlineAction)
                    this.isUnderline = !this.isUnderline;
                else
                    this.isUnderline = !this.isSelectedStyle('underline');

                this.isUnderlineAction = true;
                break;
            }
            case 11: { // super
                this.isSubAction = false;

                if (this.isSuperAction)
                    this.isSuper = !this.isSuper;
                else
                    this.isSuper = !this.isSelectedStyle('super');

                this.isSuperAction = true;
                break;
            }
            case 12: { // sub
                this.isSuperAction = false;

                if (this.isSubAction)
                    this.isSub = !this.isSub;
                else
                    this.isSub = !this.isSelectedStyle('sub');

                this.isSubAction = true;
                break;
            }
            case 14: { // font family
                this.fontFamily = value;
                this.isFontFamilyAction = true;
                break;
            }
            case 20: { // font color
                this.fontColor = value;
                this.isFontColorAction = true;
                break;
            }
            case 15: { // font size
                this.fontSize = value;
                this.isFontSizeAction = true;
                break;
            }
        }
    },
    isSelectedStyle(style) {
        switch (style) {
            case 'bold': {
                if (this.isBoldAction)
                    return this.isBold;

                break;
            }
            case 'italic': {
                if (this.isItalicAction)
                    return this.isItalic;

                break;
            }
            case 'underline': {
                if (this.isUnderlineAction)
                    return this.isUnderline;

                break;
            }
            case 'super': {
                if (this.isSubAction)
                    return false;

                if (this.isSuperAction)
                    return this.isSuper;

                break;
            }
            case 'sub': {
                if (this.isSuperAction)
                    return false;

                if (this.isSubAction)
                    return this.isSub;

                break;
            }
        }

        let selection = window.getSelection();

        if (!selection || !selection.anchorNode || (selection.anchorNode.id && selection.anchorNode.id.indexOf('text_area') != -1)) {
            if (style === 'left') // default is leftAlignment ... so if no text-align style then let it selected
                return true;
            else
                return false;
        }

        let parentNode = selection.anchorNode.parentNode;

        return this.checkStyle(parentNode, style);
    },
    checkStyle(nodeElement, style) {
        if (nodeElement && nodeElement.nodeName === 'foreignObject') {
            if (style === 'left') // default is leftAlignment ... so if no text-align style then let it selected
                return true;
            else
                return false;
        }

        if (nodeElement && nodeElement.style) {
            let cssValue;
            let isSelected = false;

            switch (style) {
                case 'bold': {
                    cssValue = nodeElement.style['font-weight'];

                    if (cssValue) {
                        if (cssValue === style)
                            isSelected = true;
                    } else
                        return this.checkStyle(nodeElement.parentNode, style);
                    break;
                }
                case 'italic': {
                    cssValue = nodeElement.style['font-style'];

                    if (cssValue) {
                        if (cssValue === style)
                            isSelected = true;
                    } else
                        return this.checkStyle(nodeElement.parentNode, style);
                    break;
                }
                case 'underline': {
                    cssValue = nodeElement.style['text-decoration-line'];

                    if (cssValue) {
                        if (cssValue === style)
                            isSelected = true;
                    } else
                        return this.checkStyle(nodeElement.parentNode, style);
                    break;
                }
                case 'super':
                case 'sub': {
                    cssValue = nodeElement.style['vertical-align'];

                    if (cssValue) {
                        if (cssValue === style)
                            isSelected = true;
                    } else
                        return this.checkStyle(nodeElement.parentNode, style);
                    break;
                }
                case 'left':
                case 'center':
                case 'right': {
                    if (style === 'left')
                        isSelected = true; // default is leftAlignment ... so if no text-align style then let it selected

                    cssValue = nodeElement.style['text-align'];

                    if (cssValue === 'left' || cssValue === 'center' || cssValue === 'right') {
                        if (cssValue === style)
                            isSelected = true;
                        else
                            isSelected = false;
                    } else
                        return this.checkStyle(nodeElement.parentNode, style);
                    break;
                }
                case 'OL':
                case 'UL': {
                    if (nodeElement.nodeName === style)
                        isSelected = true;
                    else
                        return this.checkStyle(nodeElement.parentNode, style);
                    break;
                }
            }

            return isSelected;
        } else
            return false;
    },
    getCommandValue(style) {
        switch (style) {
            case 'fontname': {
                if (this.isFontFamilyAction)
                    return this.fontFamily;

                break;
            }
            case 'fontcolor': {
                if (this.isFontColorAction)
                    return this.fontColor;

                break;
            }
            case 'fontsize': {
                if (this.isFontSizeAction)
                    return this.fontSize;

                break;
            }
        }

        let selection = window.getSelection();

        if (!selection || !selection.anchorNode || (selection.anchorNode.id && selection.anchorNode.id.indexOf('text_area') != -1)) {
            if (style === 'fontname')
                return this.currentFont;

            if (style === 'fontcolor')
                return '#000000';

            if (style === 'fontsize')
                return this.currentFontSize;
        }

        let parentNode = selection.anchorNode.parentNode;

        return this.checkCommand(parentNode, style);
    },
    checkCommand(nodeElement, style) {
        if (nodeElement && nodeElement.nodeName === 'foreignObject') {
            if (style === 'fontname')
                return this.currentFont;

            if (style === 'fontcolor')
                return '#000000';

            if (style === 'fontsize')
                return this.currentFontSize;
        }

        if (nodeElement && nodeElement.style) {
            let cssValue;

            switch (style) {
                case 'fontname': {
                    cssValue = nodeElement.style['font-family'];

                    if (cssValue)
                        return cssValue;
                    else
                        return this.checkCommand(nodeElement.parentNode, style);
                    break;
                }
                case 'fontcolor': {
                    cssValue = nodeElement.style['color'];

                    if (cssValue)
                        return cssValue;
                    else
                        return this.checkCommand(nodeElement.parentNode, style);
                    break;
                }
                case 'fontsize': {
                    cssValue = nodeElement.style['font-size'];

                    if (cssValue)
                        return parseInt(cssValue);
                    else
                        return this.checkCommand(nodeElement.parentNode, style);
                    break;
                }
            }

            return '';
        } else {
            if (style === 'fontname')
                return this.currentFont;

            if (style === 'fontcolor')
                return '#000000';

            if (style === 'fontsize')
                return this.currentFontSize;
        }
    },
    resetActions() {
        this.isBoldAction = false;
        this.isItalicAction = false;
        this.isUnderlineAction = false;
        this.isSuperAction = false;
        this.isSubAction = false;
        this.isFontColorAction = false;
        this.isFontFamilyAction = false;
        this.isFontSizeAction = false;

        this.savedSelection = undefined;
        this.lastCursorPosition = -1;
    },
    hasParentWithId(target, parentId, level) {
        if (target.id && target.id.indexOf(parentId) != -1)
            return true;

        let i;

        for (i=0; i<level; i++) {
            if (target.parentNode == undefined) {
                return false;
            } else {
                target = target.parentNode;

                if (target.id && target.id.indexOf(parentId) != -1)
                    return true;
            }
        }

        return false;
    },
    checkTextSelection(e) {
        if (e && e.target) {
            if (e.target && e.target.offsetParent && e.target.offsetParent.nodeName && e.target.offsetParent.nodeName.indexOf('foreignObject') != -1 && e.target.offsetParent.innerHTML && e.target.offsetParent.innerHTML.indexOf(this.selectedTextShape) != -1)
                return;

            if (this.hasParentWithId(e.target, 'textEditorTool', 14) || (e.target.className.length > 0 && e.target.className.indexOf('menuButton') != -1))
                return;

            if (this.hasParentWithId(e.target, 'shapeBound', 5))
                return;

            if (e.target.className && e.target.className.length > 0 && e.target.className.indexOf('undoRedo') != -1) // if it is a click on UNDO/REDO buttons
                return;
        }

        this.closeTextEditor();
    },
    closeTextEditor() {
        if (this.selectedTextShape == '')
            return;

        const activeTextArea = document.getElementById('text_area_' + this.selectedTextShape);

        if (activeTextArea) {
            const newValue = activeTextArea.innerHTML;

            if (newValue) {
                storeManager.getStore().dispatch(changeRichTextContent(this.selectedTextShape, newValue));
                saveManager.isContentChanged(true);
                audioEditorUtils.addActionToHistory();
            }

            activeTextArea.contentEditable = false;
            activeTextArea.style.cursor = 'default';
        }

        this.selectedTextShape = '';
        this.resetActions();

        if (storeManager.getState().menu.contextMode == modeType.TEXT_EDITOR)
            storeManager.getStore().dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },

    background: undefined,
    initColorPickerBackground() {
        const appBounds = document.getElementById('app').getBoundingClientRect();

        this.background = document.createElement('div');

        this.background.addEventListener('click', this.onClickBackgroundHandler.bind(this));

        this.background.style.position = 'absolute';
        this.background.style.background = 'none';
        this.background.style.display = 'block';
        this.background.style.zIndex = 99999999;
        this.background.style.left = appBounds.left + 'px';
        this.background.style.top = appBounds.top + 'px';
        this.background.style.width = appBounds.width + 'px';
        this.background.style.height = appBounds.height + 'px';
    },
    onClickBackgroundHandler() {
        if (this.background && this.background.parentNode)
            this.background.parentNode.removeChild(this.background);
    },
    addColorPickerBackground() {
        if (!this.background)
            this.initColorPickerBackground();

        document.body.appendChild(this.background);
    },

    textAreaElement: undefined,
    updateSize: true,
    updateShapeSize(shapeModel, dispatch) {
        if (!this.updateSize) {
            this.updateSize = true;
            return;
        }

        let originalTextArea = document.getElementById('text_area_' + shapeModel.uuid);

        if (!originalTextArea)
            return;

        if (!this.textAreaElement)
            this.textAreaElement = document.createElement('div');

        document.body.appendChild(this.textAreaElement);

        this.textAreaElement.innerHTML = originalTextArea.innerHTML;

        const PADDING = properties.TEXT_PADDING;
        const INNER_PADDING = properties.TEXT_INNER_PADDING;
        const textProperties = this.textProperties(shapeModel);
        const EXTRA_PADDING = textProperties.extraPadding;
        let oldHeight = shapeModel.height;
        let textAreaWidth = shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING;

        if (shapeModel.imageNode && shapeModel.imageNode.length > 0 && shapeModel.aspectRatio > 0) {
            let imageHeight = shapeModel.height - 2 * INNER_PADDING;
            let maxWidth = textAreaWidth * 0.7;
            let imageWidth = imageHeight * shapeModel.aspectRatio;

            if (imageWidth > maxWidth)
                imageWidth = maxWidth;

            textAreaWidth = textAreaWidth - imageWidth - INNER_PADDING;
        }

        this.textAreaElement.style.width = textAreaWidth + 'px';
        this.textAreaElement.style.resize = 'none';
        this.textAreaElement.style.overflow = 'hidden';
        this.textAreaElement.style.padding = INNER_PADDING + 'px';
        this.textAreaElement.style.border = 'none';
        this.textAreaElement.style.outline = 'none';
        this.textAreaElement.style.background = 'transparent';
        this.textAreaElement.style.wordSpacing = textProperties.wordSpacing + 'px';
        this.textAreaElement.style.letterSpacing = textProperties.letterSpacing + 'px';
        this.textAreaElement.style.overflowWrap = 'break-word';

        if (shapeModel.lineHeight > 0)
            this.textAreaElement.style.lineHeight = shapeModel.lineHeight;
        else {
            if (textProperties.lineHeight != -1)
                this.textAreaElement.style.lineHeight = textProperties.lineHeight;
        }

        let currentHeight = this.textAreaElement.scrollHeight;

        if (currentHeight > oldHeight) { // update when the max height is reached
            dispatch(updateTextHeight(shapeModel.uuid, currentHeight, 0));
            saveManager.isContentChanged(true);

            mindMapUtils.updateShapePositionWhenResize(shapeModel);
        }

        document.body.removeChild(this.textAreaElement);
    },
    getHtmlText(shapeModel) {
        return shapeModel.htmlText;
    },
    textProperties(shapeModel) {
        let properties = {};

        properties.wordSpacing = -1;
        properties.textIdent = 0;
        properties.letterSpacing = 0;

        if (shapeModel.lineHeight && shapeModel.lineHeight > 0)
            properties.lineHeight = shapeModel.lineHeight;
        else
            properties.lineHeight = 1.25;

        properties.extraPadding = 2;

        if (platformDetection.isEdge() || platformDetection.isFirefox() || platformDetection.isSafari())
            properties.extraPadding = 5;

        return properties;
    },
    getCorrectColor(color) {
        if (!color)
            return '#000000';

        if (color && color.indexOf('rgb(') != -1)
            color = textSizeUtils.getHexaColor(color);

        color = color.toLowerCase();

        return color;
    }
};

export default textEditorUtils;


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/utils/TextEditorUtils.js
 **/